import React, {PureComponent} from 'react';
import Gallery from 'react-photo-gallery';
import Lightbox from 'react-images';
import {PrismicImage} from "../../../prismic/utils/types";

class Photos extends PureComponent<{ photos: PrismicImage[] }> {

    state = {
        currentImage: 0,
        lightboxIsOpen: false,
    };

    openLightbox = (event, object) => {
        if (this.state.lightboxIsOpen) {
            return;
        }

        this.setState({
            currentImage: object.index,
            lightboxIsOpen: true
        });
    };

    closeLightbox = () => {
        if (!this.state.lightboxIsOpen) {
            return;
        }

        this.setState({
            currentImage: 0,
            lightboxIsOpen: false,
        });
    };

    onNextClick = () => {
        this.setState({
            currentImage: this.state.currentImage + 1,
        });
    };

    onPreviousClick = () => {
        this.setState({
            currentImage: this.state.currentImage - 1,
        });
    };

    public render() {
        return (
            <div>
                <h2>Foto's</h2>
                <p>Hieronder kunt u een kijkje nemen in onze ijssalon. Voor een beter beeld kunt u het beste zelf
                    langskomen!</p>
                <Gallery photos={this.props.photos} onClick={this.openLightbox} columns={2}/>
                <Lightbox images={this.props.photos}
                          backdropClosesModal
                          onClose={this.closeLightbox}
                          onClickPrev={this.onPreviousClick}
                          onClickNext={this.onNextClick}
                          currentImage={this.state.currentImage}
                          isOpen={this.state.lightboxIsOpen}
                />
            </div>
        )
    }
}

export default Photos;
